<template>
    <div class=""></div>
</template>
<script>
export default {
    name: "GoogleAnalyticsInertia",
    mounted() {
        this.$inertia.on("success", (event) => {
            gtag("js", new Date());
            gtag("config", window.googleAnalyticsMeasurementId);
        });
    },
};
</script>
